export const TPL_UPLOAD = {
  action: 'tpl-upload',
  tooltip: 'Загрузить предзаполнение',
  icon: 'mdi-file-upload',

}

export const TPL_DOWNLOAD = {
  action: 'tpl-download',
  tooltip: 'Получить предзаполненный шаблон',
  icon: 'mdi-file-download',
}

export const TPL_DOWNLOAD_EMPTY = {
  action: 'tpl-download-empty',
  tooltip: 'Получить пустой шаблон',
  icon: 'mdi-file-download-outline',
}
